<ng-container *ngIf="mode === 'weii'; else crremView">
<ng-container *ngIf="values?.length > 0 else noData">
    <div class="weii-history" [class.has-paris-proof]="location && parisProofValue != null"
         [style.--weii-column-count]="values.length">
        <span *ngIf="isFullElectric" class="weii-full-electric-info" tabindex="0"
              aria-label="Full Electric calculation information">
            <i class="bi bi-info-circle"></i>
            <span class="weii-full-electric-tooltip">
                This building is classified as Full Electric. The WEii score is therefore calculated using electricity data only.
            </span>
        </span>
        <div class="weii-content-region">
            <div class="weii-value-row">
                <div *ngFor="let value of values" class="weii-value" [class.is-proof]="isParisProof(value.value)">
                    <span class="weii-score-line">
                        <span class="notranslate">{{ value.value | number:'1.0-1' }}</span>
                        <span class="weii-score-unit notranslate">kWh/m<sup>2</sup></span>
                    </span>
                    <small class="weii-score-period">per year</small>
                </div>
            </div>
        </div>

        <div class="weii-track-area">
            <div *ngIf="location && parisProofValue != null" class="paris-proof-line"
                 [style.bottom.%]="parisProofLinePosition">
                <span class="paris-proof-label">
                    <span>Paris Proof</span>
                    <small class="notranslate">{{ parisProofValue }} kWh/m<sup>2</sup></small>
                </span>
            </div>
            <div class="weii-content-region weii-building-region">
                <div class="weii-buildings">
                    <div *ngFor="let value of values" class="weii-building-column">
                        <div class="weii-building" [class.is-proof]="isParisProof(value.value)"
                             [style.height.%]="getValueHeight(value.value)"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="weii-content-region">
            <div class="weii-year-row">
                <span *ngFor="let value of values">
                    <span class="notranslate">{{ value.year }}</span>
                    <small *ngIf="value.provisional">
                        Provisional
                        <span *ngIf="value.provisionalThrough" class="notranslate">
                            &middot; {{ value.provisionalThrough | date:'MMM yyyy':'UTC' }}
                        </span>
                    </small>
                </span>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #noData>
    <div class="card-subtitle d-flex text-center align-items-center w-100">
        <h2 class="flex-grow-1 weii-no-data-message">{{ noDataText }}</h2>
    </div>
</ng-template>

</ng-container>
<ng-template #crremView>
  <app-crrem-compass [location]="location" [display]="crremDisplay"></app-crrem-compass>
</ng-template>
